import CryptoJS from 'crypto-js'


export function encryptMd5(data){
    return CryptoJS.MD5(data).toString()
}

/**
 * Decrypt data using a key derived from timestamp
 * @param {string} data - Encrypted data (Base64 or Hex)
 * @param {number} timestamp - Timestamp used for key generation
 * @returns {string} Decrypted string
 */
export function getRemoveKey(data, timestamp) {
  // Convert timestamp to hex string and pad to 16 chars
  const keyStr = timestamp.toString(16).padStart(16, '0')
  
  // Parse key as UTF-8
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  
  // Decrypt using AES ECB Pkcs7
  const decrypted = CryptoJS.AES.decrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.NoPadding
  })
  
  // Convert result to UTF-8 string
  return decrypted.toString(CryptoJS.enc.Utf8)
}

//aes加密
export function encryptAes(data,key) {
  var encrypted = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(key), {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.NoPadding
  });
  return encrypted.toString(CryptoJS.enc.Utf8);
}
//解密
export function decryptAes(data, keyStr) {
  // Parse key as UTF-8
  const key = CryptoJS.enc.Utf8.parse(keyStr)
  // Decrypt using AES ECB Pkcs7
  const decrypted = CryptoJS.AES.decrypt(data, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.NoPadding
  })
  console.log('decrypted', decrypted)
  // Convert result to UTF-8 string
  return decrypted.toString(CryptoJS.enc.Utf8)
}

export function getParseKey(check, session) {
  // 生成签名key
  let md5 = encryptMd5(session)
  let key = md5.substring(0, 16)
  console.log('check', check)
  console.log('session', session)
  console.log('key', key)

  return decryptAes(check, key)
}